import React, { useEffect, useState } from "react";
import Space from "../layout/Space";
import TextField2 from "../textfields/TextField2";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { getDocDataById, updateDocDataField } from "../models/DataFunctions";
import SecondaryButton from "../buttons/SecondaryButton";
import PrimaryButton from "../buttons/PrimaryButton";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";

// Component to handle rendering of individual champ types
const ChampRenderer = ({ champ, onChange }) => {
  if (champ.type === "text") {
    return (
      <TextField2
        label={champ.name}
        value={champ.content || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  } else if (champ.type === "case") {
    return (
      <CheckBoxGrey
        checked={champ.content}
        onChange={(checked) => onChange(checked)}
      />
    );
  } else if (champ.type === "drop") {
    return (
      <DropDownGPT03
        className="w-full"
        items={champ.options.map((option) => ({
          value: option,
          label: option,
        }))}
        value={champ.content.value || ""}
        onChange={(e) => onChange(e.value)}
      />
    );
  }
  return null;
};

// Main FillFormModal component
const FillFormModal = ({ orgData, form_id, onClose, formFilled, prefix }) => {
  const [form, setForm] = useState(null);

  // Fetch form data based on form_id
  const handleFetchData = async () => {
    const fetchedForm = await getDocDataById("form", form_id);
    if (orgData.type === "client") {
      const saved_forms = orgData.saved_forms || [];
      // check if form is already saved
      const formIndex = saved_forms.findIndex((f) => f.id === form_id);
      if (formIndex !== -1) {
        setForm(saved_forms[formIndex]);
        return;
      }
    }
    setForm(fetchedForm);
  };

  useEffect(() => {
    handleFetchData();
  }, [form_id]);

  // Update a specific champ's content
  const handleChampChange = (cochampIndex, champIndex, newValue) => {
    setForm((prevForm) => {
      const updatedForm = { ...prevForm };
      updatedForm.cochamps[cochampIndex].champs[champIndex].content = newValue;
      return updatedForm;
    });
  };

  const handleFilled = async (form) => {
    formFilled(form);
    if (orgData.type === "client") {
      const saved_forms = orgData.saved_forms || [];
      // check if form is already saved
      const formIndex = saved_forms.findIndex((f) => f.id === form.id);
      if (formIndex === -1) {
        saved_forms.push(form);
        await updateDocDataFieldApi(
          orgData.ref,
          "saved_forms",
          saved_forms,
          prefix
        );
      } else {
        saved_forms[formIndex] = form;
        await updateDocDataFieldApi(
          orgData.ref,
          "saved_forms",
          saved_forms,
          prefix
        );
      }
    }
    onClose();
  };

  if (!form) return <div></div>;

  return (
    <div className="flex flex-col gap-2 bg-white p-10  rounded-xl w-c700 h-5/6 overflow-y-auto">
      {/* Form Title */}
      <div className="text-h1 font-semibold">{form.name}</div>
      <Space y={10} />

      {/* Form Champs */}
      <div className="flex flex-col gap-10">
        {form.cochamps.map((cochamp, cochampIndex) => (
          <div key={cochampIndex} className="flex flex-col gap-2">
            {/* Cochamps Title */}
            <div className="text-h2 text-black">{cochamp.name}</div>
            {cochamp.champs.map((champ, champIndex) => (
              <div
                key={`${cochampIndex}-${champIndex}`}
                className="flex flex-row gap-2 justify-start h-8 items-center"
              >
                {/* Champ Name */}
                <div className="text-h3 text-shadow_50  min-w-c150 ">
                  {champ.name}
                </div>
                {/* Champ Renderer */}
                <div className="w-full flex">
                  <ChampRenderer
                    champ={champ}
                    onChange={(newValue) =>
                      handleChampChange(cochampIndex, champIndex, newValue)
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <Space y={40} />

      <div className="flex flex-row justify-end gap-2">
        <SecondaryButton onClick={onClose}>Annuler</SecondaryButton>
        <PrimaryButton onClick={() => handleFilled(form)}>
          Valider
        </PrimaryButton>
      </div>
    </div>
  );
};

export default FillFormModal;
